import { render, staticRenderFns } from "./gestionVisitas.vue?vue&type=template&id=ef98f820"
import script from "./gestionVisitas.vue?vue&type=script&lang=js"
export * from "./gestionVisitas.vue?vue&type=script&lang=js"
import style0 from "./gestionVisitas.vue?vue&type=style&index=0&id=ef98f820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports